import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

const TaskItem = ({ task, index, onTaskClick }) => {
  const handleClick = (e) => {
    e.preventDefault()
    onTaskClick?.(task)
  }

  return (
    <div className="task">
      <div className="task__spacer" />
      <div className="task__desc">
        <a href="#" className="task__anchor" onClick={handleClick}>
          <div className="task__num">{ index + 1 }</div>
          <div className="task__name">{ task.names.en }</div>
        </a>
      </div>
      <div className="task__spacer task__actions-wrapper" />
    </div>
  )
}

const PreviewCards = ({ cards, onTaskClick, className }) => {
  if (!cards || !cards.length) {
    return null;
  }

  return (
    <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: 1 }}>
      <div className="tasks-list--main">
        <div className={classnames("tasks-list", `tasks-list--${className}`)}>
          {
            _.map(cards, (task, index) => (
              <TaskItem
                key={task.id}
                index={index}
                task={task}
                onTaskClick={onTaskClick}
              />
            ))
          }
        </div>
      </div>
    </div>
  )
}

PreviewCards.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      names: PropTypes.shape({
        en: PropTypes.string.isRequired
      }).isRequired,
      tour: PropTypes.string.isRequired
    })
  ).isRequired,
  onTaskClick: PropTypes.func,
  className: PropTypes.string
}

PreviewCards.defaultProps = {
  className: 'main',
  onTaskClick: () => {}
}

export default PreviewCards